import { z } from 'zod';
import type { AuthUser } from './auth';
import { usernameSchema } from './auth-schemas';
import { avatarSchema, type Wardrobe } from './avatar';

/**
 * The player's own profile page (2026-10-26): the name the others see and what the figure
 * wears. Mia still sells the clothes; the profile only puts on what the player owns.
 */

/** Same rules as the username: 3–16 letters, digits, - and _. */
export const renameRequestSchema = z.object({ displayName: usernameSchema });
export type RenameRequest = z.infer<typeof renameRequestSchema>;

export const wearRequestSchema = z.object({ avatar: avatarSchema });
export type WearRequest = z.input<typeof wearRequestSchema>;

export interface ProfileResponse {
  user: AuthUser;
  wardrobe: Wardrobe;
  /** PixelCoins to spend in the avatar shop. */
  balance: number;
}

export interface BuyItemResponse {
  wardrobe: Wardrobe;
  balance: number;
}
